import { PayloadAction } from "@reduxjs/toolkit";
import {
  BreadcrumbItems,
  MetaDataType,
  PartitionDataType,
  SelectedArtefactType
} from "@emisgroup/cohort-builder-kit";
import { IInitialState } from "./Types";

export const Reducer = {
  setPartitionList: (state: IInitialState, action: PayloadAction<SelectedArtefactType[]>): void => {
    state.artefacts = action.payload;
  },

  setSelectedId: (state: IInitialState, action: PayloadAction<string>): void => {
    state.selectedId = action.payload;
  },

  setBreadcrumbItems: (state: IInitialState, action: PayloadAction<BreadcrumbItems[]>): void => {
    state.breadcrumbItems = action.payload;
  },

  setParentData: (state: IInitialState, action: PayloadAction<PartitionDataType>): void => {
    state.parentData = action.payload;
  },

  setMetaData: (state: IInitialState, action: PayloadAction<MetaDataType[]>): void => {
    state.metaData = action.payload;
  }
};
